const initialState = {
    active_lesson_type: '',
    assessmentActive: false,
    current_activity: '',
    current_category: '',
    currentAssembly: '',
    videoPlayer: false,
    activity_arr: [],
    videoDuration: '0',
    isAssessmentDownloadBtn: false,
    subjectContentLoadingOnLesson: 'no loading',
    activityBtnAction: 'continue',
};

const updateLearningMaterialData = (state = initialState, action) => {
    switch (action.type) {
        case 'UPDATE_LESSON_TYPE':
            return { ...state, active_lesson_type: action.payload };
        case 'EMPTY_LESSON_TYPE':
            return { ...state, active_lesson_type: '' };
        case 'UPDATE_ASSESSMENT_ACTIVE':
            return { ...state, assessmentActive: action.payload };
        case 'EMPTY_ASSESSMENT_ACTIVE':
            return { ...state, assessmentActive: false };
        case 'UPDATE_ACTIVITY_ARR':
            return { ...state, activity_arr: action.payload };
        case 'EMPTY_ACTIVITY_ARR':
            return { ...state, activity_arr: [] };
        case 'UPDATE_CURRENT_ACTIVITY':
            return { ...state, current_activity: action.payload };
        case 'EMPTY_CURRENT_ACTIVITY':
            return { ...state, current_activity: '' };
        case 'UPDATE_SUBJECT_CONTENT_LOADING_ON_LESSON':
            return { ...state, subjectContentLoadingOnLesson: action.payload };
        case 'UPDATE_CURRENT_CATEGORY':
            return { ...state, current_category: action.payload };
        case 'EMPTY_CURRENT_CATEGORY':
            return { ...state, current_category: '' };
        case 'UPDATE_CURRENT_ASSEMBLY':
            return { ...state, currentAssembly: action.payload };
        case 'EMPTY_VIDEO_PLAYER':
            return { ...state, videoPlayer: '' };
        case 'UPDATE_VIDEO_PLAYER':
            return { ...state, videoPlayer: action.payload };
        case 'UPDATE_VIDEO_DURATION':
            return { ...state, videoDuration: action.payload };
        case 'CLEAR_VIDEO_DURATION':
            return { ...state, videoDuration: '0' };
        case 'UPDATE_IS_DOWNLOAD_ASSESSMENT':
            return { ...state, isAssessmentDownloadBtn: action.payload };
        case 'CLEAR_IS_DOWNLOAD_ASSESSMENT':
            return { ...state, isAssessmentDownloadBtn: false };
        case 'UPDATE_ACTIVITY_BTN_ACTION':
            return { ...state, activityBtnAction: action.payload };
        default:
            return state;
    }
};

export default updateLearningMaterialData;
